import edit_steps from '@/modules/CA_SP/components/actions/edit_steps.vue';
import { action_steps_info } from '@/objects/general.js';
export default {
  components:{edit_steps},
  data() {
    return {
			ext_chn_stp:0,
      steps:[],
			steps_info:action_steps_info,
    };
  },
  methods: {
		select_edit_step(item){
			this.dev_log({item});
			this.open_dialog('edit_finding');
      this.requests.get['finding_summary'](item.id)
        .then(r=>this.steps = r ? Object.keys(r).filter(k=>this.steps_info[k] && r).map(k=>Object.assign({k,data:r[k]},this.steps_info[k],{check:!!r[k].id})) : [])
		},
  },
};
